const KLAVIYO_SUBSCRIPTIONS_URL = 'https://a.klaviyo.com/client/subscriptions';
const KLAVIYO_REVISION = '2026-10-15';
const SUBSCRIBED_STORAGE_KEY = 'newsletter-subscribed-at';

class NewsletterSignup extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form || !this.dataset.companyId || !this.dataset.listId) return;

    this.input = this.form.querySelector('input[type="email"]');
    this.button = this.form.querySelector('button[type="submit"]');
    this.message = this.querySelector('[data-newsletter-message]');
    this.form.addEventListener('submit', this.handleSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit);
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    if (this.pending) return;

    const email = this.input.value.trim();
    if (!email) return;

    this.setPending(true);

    try {
      const url = `${KLAVIYO_SUBSCRIPTIONS_URL}?company_id=${encodeURIComponent(this.dataset.companyId)}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: KLAVIYO_REVISION,
        },
        body: JSON.stringify(this.buildPayload(email)),
      });

      if (!response.ok) throw new Error(`Klaviyo subscription failed with status ${response.status}`);

      this.form.reset();
      this.showMessage(this.dataset.successMessage, false);
      this.rememberSubscription();
      this.dispatchEvent(new CustomEvent('newsletter:subscribe', { bubbles: true }));
    } catch (error) {
      console.error(error);
      this.showMessage(this.dataset.errorMessage, true);
    } finally {
      this.setPending(false);
    }
  };

  buildPayload(email) {
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: this.dataset.source || undefined,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } },
                },
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: this.dataset.listId } },
        },
      },
    };
  }

  rememberSubscription() {
    try {
      localStorage.setItem(SUBSCRIBED_STORAGE_KEY, String(Date.now()));
    } catch {}
  }

  setPending(isPending) {
    this.pending = isPending;
    this.button.setAttribute('aria-disabled', String(isPending));
    this.form.setAttribute('aria-busy', String(isPending));
  }

  showMessage(text, isError) {
    if (isError) {
      this.input.setAttribute('aria-invalid', 'true');
    } else {
      this.input.removeAttribute('aria-invalid');
    }

    if (this.message) this.message.textContent = text;
  }
}

if (!customElements.get('newsletter-signup')) {
  customElements.define('newsletter-signup', NewsletterSignup);
}
